/**
 * Motion tokens — JS 측
 * 정본 매핑: resources/scss/home/abstract/_motion.scss
 * 두 파일 값은 반드시 동기 유지.
 *
 * 사용:
 *   import { DUR, EASE, STAGGER } from "../global/MotionTokens";
 *   gsap.to(el, { y: 0, opacity: 1, duration: DUR.slower, ease: EASE.outExpo });
 *   gsap.to(words, { ..., stagger: STAGGER.base });
 *
 * prefers-reduced-motion 시: motionOK() === false → duration 0 강제.
 */

export const DUR = {
    instant: 0.1,
    fast:    0.2,
    base:    0.32,
    slow:    0.56,
    slower:  0.88,
    epic:    1.2,
} as const;

/** GSAP ease 문자열 (gsap에 내장된 ease 이름 매핑) */
export const EASE = {
    outQuart: "power2.out",       // ≈ cubic-bezier(0.22, 1, 0.36, 1)
    outExpo:  "expo.out",         // ≈ cubic-bezier(0.16, 1, 0.30, 1)
    inOut:    "power2.inOut",
    spring:   "back.out(1.6)",
    linear:   "none",
} as const;

export const STAGGER = {
    fast: 0.03,   // I2 char stagger
    base: 0.06,   // I1 word mask
    slow: 0.12,   // list card entrance
} as const;

export const OFFSET_PX = {
    sm: 16,
    md: 40,
    lg: 80,
} as const;

/** prefers-reduced-motion 체크. false면 모든 모션 OFF. */
export function motionOK(): boolean {
    if (typeof window === "undefined" || !window.matchMedia) return true;
    return !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/** 모바일(< 768)에선 핀 섹션·마그네틱 OFF. plan §2.4 가드레일. */
export function isImmersiveCapable(): boolean {
    if (typeof window === "undefined") return false;
    if (!motionOK()) return false;
    return window.matchMedia("(min-width: 768px)").matches;
}
